import { DefaultLoader, LoaderContainer } from 'components/Loader';
import Head from 'components/profileNavigation/Head';
import MentorFormDisplay from 'components/UserForms/MentorForm/MentorFormDisplay';
import { FC, useContext } from 'react';
import useSWR from 'swr';
import MentorFormType from 'types/MentorForm';
import { MentorEditContext } from '.';

const MentorForm: FC = () => {
  const { mentor } = useContext(MentorEditContext);
  const { data: mentorForm, error } = useSWR<MentorFormType>(
    `/mentor-form/${mentor?.id}`,
  );

  return (
    <section>
      <Head
        title="Formulaire mentor"
        subtitle="Liste toutes les informations entrées lors de la complétion du formulaire de mentorat"
      />
      <div>
        {error ? (
          <p>L'utilisateur n'a pas encore rempli son formulaire.</p>
        ) : mentorForm ? (
          <MentorFormDisplay mentorForm={mentorForm} reader="admin" />
        ) : (
          <LoaderContainer height="20vh">
            <DefaultLoader />
          </LoaderContainer>
        )}
      </div>
    </section>
  );
};

export default MentorForm;
